import type { LocalePack } from './types.js';

/** Thai (ภาษาไทย) */
export const th: LocalePack = {
  headerTitle: 'โปรแกรมแก้ไขรูปภาพ',
  headerSubtitle: 'แก้ไขรูปของคุณได้อย่างง่ายดาย',
  applyButton: 'ใช้',
  cancelButton: 'ปิด',
  undo: 'เลิกทำ',
  redo: 'ทำซ้ำ',
  fullscreen: 'เต็มจอ',
  fit: 'พอดี',
  zoomTooltip: 'ซูม · +/− · 0 พอดี · 1 100%',

  emptyStateTitle: 'วางรูปภาพหรือคลิกเพื่ออัปโหลด',
  emptyStateSubtitle: 'รองรับ: PNG, JPEG, HEIC',

  calloutLabelText: 'ป้ายกำกับ',

  tool: {
    select: 'เลือก',
    crop: 'ครอบตัด',
    draw: 'วาด',
    eraser: 'ยางลบ',
    text: 'ข้อความ',
    shapes: 'รูปทรง',
    callout: 'คำอธิบาย',
    filters: 'ฟิลเตอร์',
    adjust: 'ปรับแต่ง',
    move: 'ย้าย',
    pen: 'ปากกา',
    zoom: 'ซูม',
    zoomIn: 'ขยาย',
    zoomOut: 'ย่อ',
    rotateLeft: 'หมุนซ้าย',
    rotateRight: 'หมุนขวา',
    flipH: 'พลิกแนวนอน',
    flipV: 'พลิกแนวตั้ง',
    reset: 'รีเซ็ต',
  },

  shape: {
    circle: 'วงกลม',
    ellipse: 'วงรี',
    square: 'สี่เหลี่ยมจัตุรัส',
    rectangle: 'สี่เหลี่ยมผืนผ้า',
    arrow: 'ลูกศร',
    polyline: 'เส้นทาง',
  },

  filter: {
    none: 'ต้นฉบับ',
    grayscale: 'ขาวดำ',
    sepia: 'ซีเปีย',
    vintage: 'วินเทจ',
    cool: 'เย็น',
    warm: 'อุ่น',
    invert: 'กลับสี',
  },

  props: {
    title: {
      draw: 'วาด',
      eraser: 'ยางลบ',
      text: 'ข้อความ',
      crop: 'ครอบตัด',
      shapes: 'รูปทรง',
      callout: 'คำอธิบาย',
      filters: 'ฟิลเตอร์',
      adjust: 'ปรับแต่ง',
      move: 'ย้าย',
    },
    aspectRatio: 'อัตราส่วนภาพ',
    applyCrop: 'ใช้การครอบตัด',
    cancel: 'ยกเลิก',
    shape: 'รูปทรง',
    preset: 'พรีเซ็ต',
    resetEffects: 'รีเซ็ตเอฟเฟกต์',
    resetAdjustments: 'รีเซ็ตการปรับแต่ง',
    deleteSelected: 'ลบที่เลือก',
    colors: 'สี',
    recent: 'ล่าสุด',
    customColor: 'สีกำหนดเอง',
    brushSize: 'ขนาดพู่กัน',
    strokeWidth: 'ความหนาเส้น',
    opacity: 'ความทึบ',
    eraserSize: 'ขนาดยางลบ',
    fontSize: 'ขนาดตัวอักษร',
    brightness: 'ความสว่าง',
    contrast: 'ความคมชัด',
    saturation: 'ความอิ่มตัว',
    blur: 'เบลอ',
    quickActions: 'การกระทำด่วน',
    hintMove:
      'ลากเพื่อเลื่อน · หนีบหรือเลื่อนเพื่อซูม · เลือกเครื่องมือเพื่อเริ่ม',
    hintEraser: 'แตะหรือลากบนคำอธิบายเพื่อลบ',
  },
};
